import React,{useEffect,useState} from 'react';
import {motion,AnimatePresence} from 'framer-motion';
import {FiLock,FiExternalLink,FiBookOpen,FiPieChart,FiCalendar,FiMessageSquare,FiBell,FiInfo,FiX,FiUser,FiPhone,FiMail,FiEye,FiUserPlus,FiChevronLeft,FiChevronRight} from 'react-icons/fi';
import ContactPopup from '../components/ContactPopup';

const WealthManagementPage=()=> {
  const [isContactPopupOpen,setIsContactPopupOpen]=useState(false);
  const [showEnrollmentInstructions,setShowEnrollmentInstructions]=useState(false);
  const [showClientSignInPopup,setShowClientSignInPopup]=useState(false);
  const [showVShareEnrollment,setShowVShareEnrollment]=useState(false);
  const [showSammonsEnrollment,setShowSammonsEnrollment]=useState(false);
  const [currentStep,setCurrentStep]=useState(0);
  
  const [vshareFormData,setVShareFormData]=useState({
    name: '',
    phone: '',
    email: ''
  });
  
  const [sammonsFormData,setSammonsFormData]=useState({
    name: '',
    phone: '',
    email: ''
  });
  
  const [vshareSubmitStatus,setVShareSubmitStatus]=useState(null);
  const [sammonsSubmitStatus,setSammonsSubmitStatus]=useState(null);
  const [vshareIsSubmitting,setVShareIsSubmitting]=useState(false);
  const [sammonsIsSubmitting,setSammonsIsSubmitting]=useState(false);

  // Complete Client Sign-in Experience images (all 6 steps)
  const imagePaths=[
    "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759344244220-page1.png",
    "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759344252771-page2.png",
    "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759344262926-page3.png",
    "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759344840722-page4.png",
    "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759344849905-page5.png",
    "https://quest-media-storage-bucket.s3.us-east-2.amazonaws.com/1759344862632-page6.png"
  ];

  useEffect(()=> {
    // Change the favicon when this page loads
    const link=document.querySelector("link[rel*='icon']") || document.createElement('link');
    link.type='image/png';
    link.rel='shortcut icon';
    link.href='/wealth-favicon.png';
    document.getElementsByTagName('head')[0].appendChild(link);

    // Change the page title
    document.title="Snow's Wealth Management";

    // Cleanup function to restore original favicon and title
    return ()=> {
      link.href='/favicon.png';
      document.title="Snow's Tax & Financial";
    };
  },[]);

  const formatPhoneNumber=(value)=> {
    const digits=value.replace(/\D/g,'');
    if (digits.length <=3) {
      return digits;
    } else if (digits.length <=6) {
      return `(${digits.slice(0,3)}) ${digits.slice(3)}`;
    } else {
      return `(${digits.slice(0,3)}) ${digits.slice(3,6)}-${digits.slice(6,10)}`;
    }
  };

  const handleVShareInputChange=(e)=> {
    const {name,value}=e.target;
    if (name==='phone') {
      const formattedPhone=formatPhoneNumber(value);
      setVShareFormData(prev=> ({...prev,[name]: formattedPhone}));
    } else {
      setVShareFormData(prev=> ({...prev,[name]: value}));
    }
  };

  const handleSammonsInputChange=(e)=> {
    const {name,value}=e.target;
    if (name==='phone') {
      const formattedPhone=formatPhoneNumber(value);
      setSammonsFormData(prev=> ({...prev,[name]: formattedPhone}));
    } else {
      setSammonsFormData(prev=> ({...prev,[name]: value}));
    }
  };

  const handleVShareSubmit=async (e)=> {
    e.preventDefault();
    setVShareIsSubmitting(true);
    
    try {
      const response=await fetch('/',{
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        body: new URLSearchParams({
          'form-name': 'vshare-enrollment',
          'service-type': 'VShare Retirement Account Access',
          ...vshareFormData
        }).toString()
      });

      if (response.ok) {
        setVShareSubmitStatus('success');
        setVShareFormData({name: '',phone: '',email: ''});
        setTimeout(()=> {
          setShowVShareEnrollment(false);
          setVShareSubmitStatus(null);
        },3000);
      } else {
        setVShareSubmitStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:',error);
      setVShareSubmitStatus('error');
    } finally {
      setVShareIsSubmitting(false);
    }
  };

  const handleSammonsSubmit=async (e)=> {
    e.preventDefault();
    setSammonsIsSubmitting(true);
    
    try {
      const response=await fetch('/',{
        method: 'POST',
        headers: {'Content-Type': 'application/x-www-form-urlencoded'},
        body: new URLSearchParams({
          'form-name': 'sammons-enrollment',
          'service-type': 'Sammons Retirement Login',
          ...sammonsFormData
        }).toString()
      });

      if (response.ok) {
        setSammonsSubmitStatus('success');
        setSammonsFormData({name: '',phone: '',email: ''});
        setTimeout(()=> {
          setShowSammonsEnrollment(false);
          setSammonsSubmitStatus(null);
        },3000);
      } else {
        setSammonsSubmitStatus('error');
      }
    } catch (error) {
      console.error('Form submission error:',error);
      setSammonsSubmitStatus('error');
    } finally {
      setSammonsIsSubmitting(false);
    }
  };

  const openContactForm=(e)=> {
    e.preventDefault();
    setIsContactPopupOpen(true);
  };

  const closeContactForm=()=> {
    setIsContactPopupOpen(false);
  };

  const openEnrollmentInstructions=(e)=> {
    e.preventDefault();
    setShowEnrollmentInstructions(true);
  };

  const closeEnrollmentInstructions=()=> {
    setShowEnrollmentInstructions(false);
  };

  const openClientSignInPopup=(e)=> {
    e.preventDefault();
    setShowClientSignInPopup(true);
    setCurrentStep(0);
  };

  const closeClientSignInPopup=()=> {
    setShowClientSignInPopup(false);
    setCurrentStep(0);
  };

  const handlePrevStep=()=> {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const handleNextStep=()=> {
    if (currentStep < imagePaths.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900">
      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-r from-gray-800 to-gray-700 text-white">
        <div className="container mx-auto px-4">
          <motion.div
            initial={{opacity: 0,y: 30}}
            animate={{opacity: 1,y: 0}}
            transition={{duration: 0.8}}
            className="text-center"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-6">Snow's Wealth Management</h1>
            <p className="text-xl max-w-3xl mx-auto text-gray-200">
              Real-time market data,insights,and investment tools to help you make informed financial decisions.
            </p>
          </motion.div>
        </div>
      </section>

      {/* Market Ticker */}
      <section className="bg-gray-800 shadow-lg">
        <div className="w-full">
          <motion.div
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            transition={{duration: 0.8,delay: 0.2}}
            className="h-16"
          >
            <iframe
              style={{border: 'none',width: '100%',height: '100%'}}
              data-widget-name="TickerTape"
              src="https://widget.darqube.com/ticker-tape?token=68b33921e65be11141c4027c"
              id="TickerTape-y4n78ny"
              title="Market Ticker Tape"
            />
          </motion.div>
        </div>
      </section>

      {/* Main Content Grid */}
      <div className="container mx-auto px-4 py-8">
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
          {/* Left Sidebar - News & Quick Access */}
          <motion.div
            initial={{opacity: 0,x: -30}}
            animate={{opacity: 1,x: 0}}
            transition={{duration: 0.8,delay: 0.3}}
            className="lg:col-span-1 space-y-6"
          >
            {/* Financial News */}
            <div className="bg-gray-800 rounded-lg shadow-lg p-6 border border-gray-700">
              <h2 className="text-2xl font-bold mb-4 text-white">Financial News</h2>
              <div className="overflow-hidden rounded-lg">
                <iframe
                  style={{border: 'none',width: '100%',height: '600px'}}
                  data-widget-name="NewsWidget"
                  src="https://widget.darqube.com/news-widget?token=68b33cf3e65be11141c40355"
                  id="NewsWidget-urralkd"
                  title="Financial News Widget"
                />
              </div>
            </div>

            {/* Quick Access Sidebar */}
            <div className="bg-gray-800 rounded-lg shadow-lg p-6 border border-gray-700">
              <h2 className="text-2xl font-bold mb-4 text-white">Quick Access</h2>
              
              {/* Schedule Appointment */}
              <div className="mb-6 p-4 bg-gray-700 rounded-lg border border-gray-600 hover:bg-gray-600 transition-colors">
                <div className="flex items-center mb-3">
                  <FiCalendar className="text-blue-400 mr-3" size={24} />
                  <h3 className="text-lg font-semibold text-white">Schedule Appointment</h3>
                </div>
                <p className="text-gray-300 text-sm mb-4">
                  Book a consultation with our financial advisors to discuss your wealth management goals and strategies.
                </p>
                <a
                  href="https://lunacal.ai/simeon-snow"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors flex items-center justify-center group text-sm"
                >
                  <span>Schedule Now</span>
                  <FiExternalLink className="ml-2 group-hover:translate-x-1 transition-transform" size={14} />
                </a>
              </div>

              {/* Financial Peace University */}
              <div className="mb-6 p-4 bg-gray-700 rounded-lg border border-gray-600 hover:bg-gray-600 transition-colors">
                <div className="flex items-center mb-3">
                  <FiBookOpen className="text-green-400 mr-3" size={24} />
                  <h3 className="text-lg font-semibold text-white">Financial Peace University</h3>
                </div>
                <p className="text-gray-300 text-sm mb-3">
                  Request complimentary access to Dave Ramsey's Financial Peace University. Available for active wealth management clients.{' '}
                  <button
                    onClick={openEnrollmentInstructions}
                    className="text-blue-400 hover:text-blue-300 underline inline-flex items-center"
                  >
                    Enrollment Instructions
                    <FiInfo className="ml-1" size={12} />
                  </button>
                </p>
                <a
                  href="https://financial-peace-university.systeme.io/dashboard/en/login"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded-lg transition-colors flex items-center justify-center group text-sm"
                >
                  <span>Access FPU</span>
                  <FiExternalLink className="ml-2 group-hover:translate-x-1 transition-transform" size={14} />
                </a>
              </div>

              {/* 1040 Analysis */}
              <div className="p-4 bg-gray-700 rounded-lg border border-gray-600 hover:bg-gray-600 transition-colors">
                <div className="flex items-center mb-3">
                  <FiPieChart className="text-blue-400 mr-3" size={24} />
                  <h3 className="text-lg font-semibold text-white">1040 Analysis</h3>
                </div>
                <p className="text-gray-300 text-sm mb-4">
                  Advanced tax return analysis tool for comprehensive financial planning and tax optimization strategies.
                </p>
                <a
                  href="https://1040strategist.netlify.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors flex items-center justify-center group text-sm"
                >
                  <span>Open Analysis Tool</span>
                  <FiExternalLink className="ml-2 group-hover:translate-x-1 transition-transform" size={14} />
                </a>
              </div>
            </div>
          </motion.div>

          {/* Main Content Area */}
          <div className="lg:col-span-2 space-y-6">
            {/* Retirement Account Access Section - Mobile First */}
            <motion.div
              initial={{opacity: 0,y: 30}}
              animate={{opacity: 1,y: 0}}
              transition={{duration: 0.8,delay: 0.4}}
              className="bg-gray-800 rounded-lg shadow-lg p-6 md:p-8 border border-gray-700 order-first lg:order-none"
            >
              <div className="text-center mb-6 md:mb-8">
                <h2 className="text-2xl md:text-3xl font-bold mb-4 text-white">Retirement Account Access</h2>
                <p className="text-gray-300 mb-6 md:mb-8">
                  Access your retirement accounts and manage your investments securely.
                </p>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
                {/* VShare Login */}
                <div className="bg-gray-700 rounded-lg p-4 md:p-6 hover:bg-gray-600 transition-colors border border-gray-600">
                  <div className="flex items-center justify-center mb-4">
                    <FiLock className="text-blue-400" size={24} />
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-white mb-3 text-center">
                    Retirement Account Access
                  </h3>
                  <p className="text-gray-300 mb-4 md:mb-6 text-center text-sm">
                    Access your retirement accounts,view balances,and manage your portfolio.
                  </p>
                  
                  {/* View Client Sign-in Experience Link */}
                  <div className="mb-4 text-center">
                    <button
                      onClick={openClientSignInPopup}
                      className="text-blue-400 hover:text-blue-300 underline text-sm flex items-center justify-center mx-auto"
                    >
                      <FiEye className="mr-1" size={14} />
                      View Client Sign-in Experience
                    </button>
                  </div>
                  
                  <a
                    href="https://www.visinvestor.com/tf/VShare"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors flex items-center justify-center group mb-3"
                  >
                    <span>Login to VShare</span>
                    <FiExternalLink className="ml-2 group-hover:translate-x-1 transition-transform" size={16} />
                  </a>
                  
                  {/* Enroll for Online Access */}
                  <button
                    onClick={()=> setShowVShareEnrollment(true)}
                    className="w-full bg-green-600 hover:bg-green-700 text-white font-medium py-2 px-4 rounded-lg transition-colors flex items-center justify-center text-sm"
                  >
                    <FiUserPlus className="mr-2" size={14} />
                    Enroll for Online Access
                  </button>
                </div>

                {/* Sammons Retirement Login */}
                <div className="bg-gray-700 rounded-lg p-4 md:p-6 hover:bg-gray-600 transition-colors border border-gray-600">
                  <div className="flex items-center justify-center mb-4">
                    <FiLock className="text-green-400" size={24} />
                  </div>
                  <h3 className="text-lg md:text-xl font-bold text-white mb-3 text-center">
                    Sammons Retirement Login
                  </h3>
                  <p className="text-gray-300 mb-4 md:mb-6 text-center text-sm">
                    Access your Sammons retirement services and account information.
                  </p>
                  
                  <a
                    href="https://www.midlandnational.com/srs-serviceloginpage"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="w-full bg-green-600 hover:bg-green-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors flex items-center justify-center group mb-3"
                  >
                    <span>Login to Sammons</span>
                    <FiExternalLink className="ml-2 group-hover:translate-x-1 transition-transform" size={16} />
                  </a>
                  
                  {/* Enroll for Online Access */}
                  <button
                    onClick={()=> setShowSammonsEnrollment(true)}
                    className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg transition-colors flex items-center justify-center text-sm"
                  >
                    <FiUserPlus className="mr-2" size={14} />
                    Enroll for Online Access
                  </button>
                </div>
              </div>
            </motion.div>

            {/* Stock Screener */}
            <motion.div
              initial={{opacity: 0,y: 30}}
              animate={{opacity: 1,y: 0}}
              transition={{duration: 0.8,delay: 0.5}}
              className="bg-gray-800 rounded-lg shadow-lg p-6 border border-gray-700"
            >
              <h2 className="text-2xl font-bold mb-4 text-white">Stock Screener</h2>
              <div className="h-96 rounded-lg overflow-hidden">
                <iframe
                  style={{border: 'none',width: '100%',height: '100%'}}
                  data-widget-name="ScreenerWidget"
                  src="https://widget.darqube.com/screener-widget?token=68b343569b3ae0653cb89be0"
                  id="ScreenerWidget-m4pfqxs"
                  title="Stock Screener Widget"
                />
              </div>
            </motion.div>

            {/* Putnam Funds Chart */}
            <motion.div
              initial={{opacity: 0,y: 30}}
              animate={{opacity: 1,y: 0}}
              transition={{duration: 0.8,delay: 0.6}}
              className="bg-gray-800 rounded-lg shadow-lg p-6 border border-gray-700"
            >
              <h2 className="text-2xl font-bold mb-4 text-white">Putnam Funds Performance</h2>
              <div className="h-96 rounded-lg overflow-hidden">
                <iframe
                  style={{border: 'none',width: '100%',height: '100%'}}
                  data-widget-name="ChartWidget"
                  src="https://widget.darqube.com/chart-widget?token=68b3401688077d4c1636c0bd"
                  id="ChartWidget-i7o923w"
                  title="Putnam Funds Chart"
                />
              </div>
            </motion.div>
          </div>

          {/* Right Sidebar - Market Overview & Contact */}
          <motion.div
            initial={{opacity: 0,x: 30}}
            animate={{opacity: 1,x: 0}}
            transition={{duration: 0.8,delay: 0.7}}
            className="lg:col-span-1 space-y-6"
          >
            {/* Market Overview */}
            <div className="bg-gray-800 rounded-lg shadow-lg p-6 border border-gray-700">
              <h2 className="text-2xl font-bold mb-4 text-white">Market Overview</h2>
              <div className="overflow-hidden rounded-lg">
                <iframe
                  style={{border: 'none',width: '100%',height: '800px'}}
                  data-widget-name="MarketOverview"
                  src="https://widget.darqube.com/market-overview?token=68b33e4a88077d4c1636c048"
                  id="MarketOverview-e12ph6g"
                  title="Market Overview Widget"
                />
              </div>
            </div>

            {/* Contact Us Module */}
            <div className="bg-gray-800 rounded-lg shadow-lg p-6 border border-gray-700">
              <h2 className="text-2xl font-bold mb-4 text-white">Get In Touch</h2>
              <p className="text-gray-300 mb-6 text-sm">
                Have questions about your investments or need personalized advice? Our team is here to help.
              </p>
              <button
                onClick={openContactForm}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-4 rounded-lg transition-colors flex items-center justify-center group"
              >
                <FiMessageSquare className="mr-2" size={18} />
                <span>Contact Us</span>
              </button>
            </div>

            {/* Announcements Module */}
            <div className="bg-gray-800 rounded-lg shadow-lg p-6 border border-gray-700">
              <div className="flex items-center mb-4">
                <FiBell className="text-yellow-400 mr-3" size={24} />
                <h2 className="text-2xl font-bold text-white">Announcements</h2>
              </div>
              <div className="space-y-4">
                <div className="bg-gray-700 rounded-lg p-4 border border-gray-600">
                  <div className="flex items-start">
                    <div className="w-2 h-2 bg-green-400 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <div>
                      <h3 className="text-white font-medium text-sm mb-1">Beneficiary Reviews</h3>
                      <p className="text-gray-300 text-xs">Scheduled for 05/20/2026</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-700 rounded-lg p-4 border border-gray-600">
                  <div className="flex items-start">
                    <div className="w-2 h-2 bg-blue-400 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <div>
                      <h3 className="text-white font-medium text-sm mb-1">Annual & Semi-Annual Reviews</h3>
                      <p className="text-gray-300 text-xs">TBA</p>
                    </div>
                  </div>
                </div>
                <div className="bg-gray-700 rounded-lg p-4 border border-gray-600">
                  <div className="flex items-start">
                    <div className="w-2 h-2 bg-purple-400 rounded-full mt-2 mr-3 flex-shrink-0"></div>
                    <div>
                      <h3 className="text-white font-medium text-sm mb-1">Educational Workshop</h3>
                      <p className="text-gray-300 text-xs">Tax Optimization Strategies TBA</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Disclaimer Section */}
        <motion.div
          initial={{opacity: 0,y: 30}}
          animate={{opacity: 1,y: 0}}
          transition={{duration: 0.8,delay: 0.8}}
          className="mt-12 bg-gray-800 rounded-lg p-8 border-l-4 border-blue-600 border border-gray-700"
        >
          <h3 className="text-xl font-bold mb-4 text-white">Investment Disclaimer</h3>
          <p className="text-gray-300 leading-relaxed">
            The information provided on this page is for informational purposes only and does not constitute investment advice. Securities offered through Ausdal Financial Partners,Inc.,Member FINRA/SIPC. Snow's Tax & Financial and Ausdal Financial Partners,Inc. are separately owned and operated. All investment decisions should be made in consultation with a qualified financial advisor. Past performance does not guarantee future results.
          </p>
        </motion.div>
      </div>

      {/* Contact Popup */}
      <ContactPopup isOpen={isContactPopupOpen} onClose={closeContactForm} />

      {/* Complete Client Sign-in Experience Popup with All 6 Steps */}
      <AnimatePresence>
        {showClientSignInPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70">
            <motion.div
              initial={{opacity: 0,scale: 0.9,y: 20}}
              animate={{opacity: 1,scale: 1,y: 0}}
              exit={{opacity: 0,scale: 0.9,y: 20}}
              className="bg-white rounded-lg shadow-xl w-full max-w-4xl mx-4 max-h-[90vh] overflow-hidden relative"
              onClick={(e)=> e.stopPropagation()}
            >
              <div className="flex justify-between items-center p-6 border-b border-gray-200">
                <h2 className="text-2xl font-bold text-gray-900">Client Sign-in Experience</h2>
                <button onClick={closeClientSignInPopup} className="text-gray-400 hover:text-gray-600">
                  <FiX size={24} />
                </button>
              </div>
              
              <div className="p-6">
                {/* Step Image Container */}
                <div className="mb-6">
                  <img
                    src={imagePaths[currentStep]}
                    alt={`Step ${currentStep + 1}`}
                    className="w-full h-auto rounded-lg shadow-lg"
                    style={{maxHeight: '500px',objectFit: 'contain'}}
                  />
                </div>

                {/* Navigation Buttons */}
                <div className="flex justify-between items-center">
                  <button
                    onClick={handlePrevStep}
                    disabled={currentStep === 0}
                    className="flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  >
                    <FiChevronLeft className="mr-2" size={20} />
                    BACK
                  </button>

                  <div className="text-sm text-gray-600">
                    Step {currentStep + 1} of {imagePaths.length}
                  </div>

                  <button
                    onClick={handleNextStep}
                    disabled={currentStep === imagePaths.length - 1}
                    className="flex items-center px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
                  >
                    NEXT
                    <FiChevronRight className="ml-2" size={20} />
                  </button>
                </div>

                {/* Step Indicators */}
                <div className="flex justify-center mt-4 space-x-2">
                  {imagePaths.map((_,index)=> (
                    <button
                      key={index}
                      onClick={()=> setCurrentStep(index)}
                      className={`w-3 h-3 rounded-full transition-colors ${
                        currentStep === index ? 'bg-blue-600' : 'bg-gray-300 hover:bg-gray-400'
                      }`}
                    />
                  ))}
                </div>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>

      {/* VShare Enrollment Modal */}
      <AnimatePresence>
        {showVShareEnrollment && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" onClick={()=> setShowVShareEnrollment(false)}>
            <motion.div
              initial={{opacity: 0,scale: 0.9,y: 20}}
              animate={{opacity: 1,scale: 1,y: 0}}
              exit={{opacity: 0,scale: 0.9,y: 20}}
              className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 max-h-[90vh] overflow-hidden"
              onClick={(e)=> e.stopPropagation()}
            >
              <div className="flex justify-between items-center p-6 border-b border-gray-200">
                <h2 className="text-xl font-bold text-gray-900">Enroll for VShare Online Access</h2>
                <button onClick={()=> setShowVShareEnrollment(false)} className="text-gray-400 hover:text-gray-600">
                  <FiX size={24} />
                </button>
              </div>
              <div className="p-6">
                {vshareSubmitStatus==='success' ? (
                  <div className="text-center">
                    <div className="mb-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
                      <h4 className="font-semibold mb-2">Thank You!</h4>
                      <p>Your enrollment request has been submitted successfully. We will set up your online access within 24 hours or less.</p>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                      <p className="text-blue-800 text-sm">
                        <strong>Important:</strong> The information you provide must match exactly what you provided in your paperwork to ensure proper account setup.
                      </p>
                    </div>

                    {vshareSubmitStatus==='error' && (
                      <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                        Sorry,there was an error submitting your request. Please try again.
                      </div>
                    )}

                    <form onSubmit={handleVShareSubmit} name="vshare-enrollment" data-netlify="true" method="POST">
                      <input type="hidden" name="form-name" value="vshare-enrollment" />
                      <input type="hidden" name="service-type" value="VShare Retirement Account Access" />
                      
                      <div className="mb-4">
                        <label htmlFor="vshare-name" className="block text-sm font-medium text-gray-700 mb-2">
                          <FiUser className="inline mr-1" />
                          Full Name: *
                        </label>
                        <input
                          type="text"
                          id="vshare-name"
                          name="name"
                          value={vshareFormData.name}
                          onChange={handleVShareInputChange}
                          required
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-colors"
                          placeholder="Enter your full name as it appears on your paperwork"
                        />
                      </div>

                      <div className="mb-4">
                        <label htmlFor="vshare-phone" className="block text-sm font-medium text-gray-700 mb-2">
                          <FiPhone className="inline mr-1" />
                          Phone Number: *
                        </label>
                        <input
                          type="tel"
                          id="vshare-phone"
                          name="phone"
                          value={vshareFormData.phone}
                          onChange={handleVShareInputChange}
                          required
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-colors"
                          placeholder="(555) 123-4567"
                          maxLength="14"
                        />
                      </div>

                      <div className="mb-6">
                        <label htmlFor="vshare-email" className="block text-sm font-medium text-gray-700 mb-2">
                          <FiMail className="inline mr-1" />
                          Email Address: *
                        </label>
                        <input
                          type="email"
                          id="vshare-email"
                          name="email"
                          value={vshareFormData.email}
                          onChange={handleVShareInputChange}
                          required
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-colors"
                          placeholder="your.email@example.com"
                        />
                      </div>

                      <button
                        type="submit"
                        disabled={vshareIsSubmitting}
                        className="w-full bg-blue-600 text-white py-3 px-4 rounded-lg hover:bg-blue-700 focus:ring-4 focus:ring-blue-200 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        {vshareIsSubmitting ? 'Submitting...' : 'Submit Enrollment Request'}
                      </button>
                    </form>
                  </>
                )}
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>

      {/* Sammons Enrollment Modal */}
      <AnimatePresence>
        {showSammonsEnrollment && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" onClick={()=> setShowSammonsEnrollment(false)}>
            <motion.div
              initial={{opacity: 0,scale: 0.9,y: 20}}
              animate={{opacity: 1,scale: 1,y: 0}}
              exit={{opacity: 0,scale: 0.9,y: 20}}
              className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4 max-h-[90vh] overflow-hidden"
              onClick={(e)=> e.stopPropagation()}
            >
              <div className="flex justify-between items-center p-6 border-b border-gray-200">
                <h2 className="text-xl font-bold text-gray-900">Enroll for Sammons Online Access</h2>
                <button onClick={()=> setShowSammonsEnrollment(false)} className="text-gray-400 hover:text-gray-600">
                  <FiX size={24} />
                </button>
              </div>
              <div className="p-6">
                {sammonsSubmitStatus==='success' ? (
                  <div className="text-center">
                    <div className="mb-4 p-4 bg-green-100 border border-green-400 text-green-700 rounded-lg">
                      <h4 className="font-semibold mb-2">Thank You!</h4>
                      <p>Your enrollment request has been submitted successfully. We will set up your online access within 24 hours or less.</p>
                    </div>
                  </div>
                ) : (
                  <>
                    <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
                      <p className="text-blue-800 text-sm">
                        <strong>Important:</strong> The information you provide must match exactly what you provided in your paperwork to ensure proper account setup.
                      </p>
                    </div>

                    {sammonsSubmitStatus==='error' && (
                      <div className="mb-4 p-3 bg-red-100 border border-red-400 text-red-700 rounded-lg">
                        Sorry,there was an error submitting your request. Please try again.
                      </div>
                    )}

                    <form onSubmit={handleSammonsSubmit} name="sammons-enrollment" data-netlify="true" method="POST">
                      <input type="hidden" name="form-name" value="sammons-enrollment" />
                      <input type="hidden" name="service-type" value="Sammons Retirement Login" />
                      
                      <div className="mb-4">
                        <label htmlFor="sammons-name" className="block text-sm font-medium text-gray-700 mb-2">
                          <FiUser className="inline mr-1" />
                          Full Name: *
                        </label>
                        <input
                          type="text"
                          id="sammons-name"
                          name="name"
                          value={sammonsFormData.name}
                          onChange={handleSammonsInputChange}
                          required
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-colors"
                          placeholder="Enter your full name as it appears on your paperwork"
                        />
                      </div>

                      <div className="mb-4">
                        <label htmlFor="sammons-phone" className="block text-sm font-medium text-gray-700 mb-2">
                          <FiPhone className="inline mr-1" />
                          Phone Number: *
                        </label>
                        <input
                          type="tel"
                          id="sammons-phone"
                          name="phone"
                          value={sammonsFormData.phone}
                          onChange={handleSammonsInputChange}
                          required
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-colors"
                          placeholder="(555) 123-4567"
                          maxLength="14"
                        />
                      </div>

                      <div className="mb-6">
                        <label htmlFor="sammons-email" className="block text-sm font-medium text-gray-700 mb-2">
                          <FiMail className="inline mr-1" />
                          Email Address: *
                        </label>
                        <input
                          type="email"
                          id="sammons-email"
                          name="email"
                          value={sammonsFormData.email}
                          onChange={handleSammonsInputChange}
                          required
                          className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-colors"
                          placeholder="your.email@example.com"
                        />
                      </div>

                      <button
                        type="submit"
                        disabled={sammonsIsSubmitting}
                        className="w-full bg-green-600 text-white py-3 px-4 rounded-lg hover:bg-green-700 focus:ring-4 focus:ring-green-200 transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
                      >
                        {sammonsIsSubmitting ? 'Submitting...' : 'Submit Enrollment Request'}
                      </button>
                    </form>
                  </>
                )}
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>

      {/* Enrollment Instructions Modal */}
      <AnimatePresence>
        {showEnrollmentInstructions && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" onClick={closeEnrollmentInstructions}>
            <motion.div
              initial={{opacity: 0,scale: 0.9,y: 20}}
              animate={{opacity: 1,scale: 1,y: 0}}
              exit={{opacity: 0,scale: 0.9,y: 20}}
              className="bg-white rounded-lg shadow-xl w-full max-w-2xl mx-4 max-h-[90vh] overflow-hidden"
              onClick={(e)=> e.stopPropagation()}
            >
              <div className="flex justify-between items-center p-6 border-b border-gray-200">
                <h2 className="text-2xl font-bold text-gray-900">Enrollment Instructions</h2>
                <button onClick={closeEnrollmentInstructions} className="text-gray-400 hover:text-gray-600">
                  <FiX size={24} />
                </button>
              </div>
              <div className="p-6 overflow-y-auto max-h-[calc(90vh-120px)]">
                <div className="space-y-4 text-gray-700">
                  <h3 className="text-lg font-semibold text-gray-900">Instructions to Enroll:</h3>
                  
                  <div className="bg-blue-50 border border-blue-200 rounded-lg p-4">
                    <p className="font-medium mb-2">Enrollment Page:</p>
                    <a
                      href="https://financial-peace-university.systeme.io/cad5d1c4"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:underline break-all"
                    >
                      https://financial-peace-university.systeme.io/cad5d1c4
                    </a>
                  </div>
                  
                  <div>
                    <h4 className="font-semibold mb-3">After Enrollment,Complete the Steps Below:</h4>
                    <ol className="list-decimal list-inside space-y-2 text-sm">
                      <li>
                        <strong>Go to the Login Page:</strong>{' '}
                        <a
                          href="https://financial-peace-university.systeme.io/dashboard/en/login"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 hover:underline"
                        >
                          https://financial-peace-university.systeme.io/dashboard/en/login
                        </a>
                      </li>
                      <li><strong>Choose:</strong> "Forgot Password"</li>
                      <li>Enter your email address that you just enrolled with & choose reset password</li>
                      <li>Go to your email & find the email from Systeme.io & click the link to reset your password</li>
                      <li>Set your password credentials</li>
                      <li>Login with your email address & newly set password credentials from the Login Page</li>
                      <li>Begin your courses!</li>
                    </ol>
                  </div>
                  
                  <div className="bg-green-50 border border-green-200 rounded-lg p-4 mt-6">
                    <p className="font-medium mb-2">Login Page:</p>
                    <a
                      href="https://financial-peace-university.systeme.io/dashboard/en/login"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-green-600 hover:underline break-all"
                    >
                      https://financial-peace-university.systeme.io/dashboard/en/login
                    </a>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        )}
      </AnimatePresence>

      {/* Widget Message Handlers */}
      <script dangerouslySetInnerHTML={{__html: `
        window.top.addEventListener("message",function(msg) {
          // Ticker Tape Handler
          const tickerWidget=document.getElementById('TickerTape-y4n78ny');
          if (tickerWidget) {
            const styles=msg.data?.styles;
            const token=msg.data?.token;
            const urlToken=new URL(tickerWidget.src)?.searchParams?.get?.('token');
            if (styles && token===urlToken) {
              Object.keys(styles).forEach(key=> tickerWidget.style.setProperty(key,styles[key]))
            }
            const height=msg.data?.tickerTapeHeight;
            if (height) {
              tickerWidget.style.setProperty('height',height + 'px');
            }
          }

          // News Widget Handler
          const newsWidget=document.getElementById('NewsWidget-urralkd');
          if (newsWidget) {
            const styles=msg.data?.styles;
            const token=msg.data?.token;
            const urlToken=new URL(newsWidget.src)?.searchParams?.get?.('token');
            if (styles && token===urlToken) {
              Object.keys(styles).forEach(key=> newsWidget.style.setProperty(key,styles[key]))
            }
          }

          // Market Overview Handler
          const marketWidget=document.getElementById('MarketOverview-e12ph6g');
          if (marketWidget) {
            const styles=msg.data?.styles;
            const token=msg.data?.token;
            const urlToken=new URL(marketWidget.src)?.searchParams?.get?.('token');
            if (styles && token===urlToken) {
              Object.keys(styles).forEach(key=> marketWidget.style.setProperty(key,styles[key]))
            }
          }

          // Putnam Funds Chart Handler
          const putnamWidget=document.getElementById('ChartWidget-i7o923w');
          if (putnamWidget) {
            const styles=msg.data?.styles;
            const token=msg.data?.token;
            const urlToken=new URL(putnamWidget.src)?.searchParams?.get?.('token');
            if (styles && token===urlToken) {
              Object.keys(styles).forEach(key=> putnamWidget.style.setProperty(key,styles[key]))
            }
          }

          // Stock Screener Handler
          const screenerWidget=document.getElementById('ScreenerWidget-m4pfqxs');
          if (screenerWidget) {
            const styles=msg.data?.styles;
            const token=msg.data?.token;
            const urlToken=new URL(screenerWidget.src)?.searchParams?.get?.('token');
            if (styles && token===urlToken) {
              Object.keys(styles).forEach(key=> screenerWidget.style.setProperty(key,styles[key]))
            }
          }
        });
      `}} />
    </div>
  );
};

export default WealthManagementPage;